export default function InitNavDrawer() {
	const toggler = document.querySelector('.navbar-toggler');
	const drawer = document.getElementById('navDrawer');
	if (!toggler || !drawer) return;

	const overlay = drawer.querySelector('.nav-drawer__overlay');
	const body = document.body;

	function open() {
		body.classList.add('is-drawer-open');
		toggler.setAttribute('aria-expanded', 'true');
	}

	function close() {
		body.classList.remove('is-drawer-open');
		toggler.setAttribute('aria-expanded', 'false');
	}

	toggler.addEventListener('click', () => {
		body.classList.contains('is-drawer-open') ? close() : open();
	});

	overlay.addEventListener('click', close);

	document.addEventListener('keydown', (e) => {
		if (e.key === 'Escape' && body.classList.contains('is-drawer-open')) {
			close();
		}
	});
}
